import createApiServices from "./createApiServices"
import {getRefreshToken} from "../AuthServices"

const prefixURL = process.env.REACT_APP_URL_AUTH || 'https://fulfillment-staging.merchize.com/api/auth'
const department = process.env.REACT_APP_DEPARTMENT || '658e8e26e05f5ee84ccffc47'
const api = createApiServices({baseUrl: prefixURL})

export const userSignIn = (data) => {
    return api.makeRequest({
        url: `/auth/login?department=${department}`,
        method: 'POST',
        data,
    })
}
export const createUser = (data = {}) => {
    return api.makeAuthRequest({
        url: `/users/create`,
        method: 'POST',
        data,
    })
}
export const editUser = (userId, data) => {
    return api.makeAuthRequest({
        url: `/users/${userId}`,
        method: 'PUT',
        data,
    })
}
export const userChangePassword = (userId, data) => {
    return api.makeAuthRequest({
        url: `/users/${userId}/change-password`,
        method: 'POST',
        data,
    })
}
export const searchUser = (data) => {
    return api.makeAuthRequest({
        url: '/users/search',
        method: 'POST',
        data,
    })
}

export const deleteUser = (userId) => {
    return api.makeAuthRequest({
        url: `/users/${userId}`,
        method: 'DELETE',
    })
}

export const userList = (query, data) => {
    return api.makeAuthRequest({
        url: `users/list?${query}`,
        method: 'POST',
        data,
    })
}

// export const getUserList = (query, data) => {
//     return api.makeAuthRequest({
//         url: `users?${query}`,
//         method: 'GET',
//         data,
//     })
// }

export const getUserList = (query) => {
    return api.makeAuthRequest({
        url: `users`,
        method: 'GET',
        params: query,
    })
}

export const getUser = (userId) => {
    return api.makeAuthRequest({
        url: `/users/${userId}`,
        method: 'GET',
    })
}

export const refreshToken = (data) => {
    return api.makeAuthRequest({
        url: '/auth/refresh-token',
        method: 'POST',
        data: {
            refreshToken: getRefreshToken(),
        },
    })
}

export const getRoleList = () => {
    return api.makeAuthRequest({
        url: '/roles',
        method: 'GET',
    })
}
